module.exports = __webpack_public_path__ + "img/cx.fed487bd.png";